import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useChatStore from "../store/useChatStore";
import ChatHeader from "../components/bizzieChat/ChatHeader";  // Chat header
import ChatSection from "../components/bizzieChat/ChatSection";  // Chat Section
import usePageTitle from "../hooks/usePageTitle";
import { checkCustomerStatus } from "../services/leadService";

const Bizzie = () => {
    usePageTitle('page-title','bizzieChatPage')
    const navigate = useNavigate();
    const customer = useChatStore((state) => state.customer);

    const [checkingStatus, setCheckingStatus] = React.useState(true);

    // Redirect if user is not logged in; otherwise defer rendering until we verify status
    useEffect(() => {
        console.log("[DEBUG] Bizzie component loaded");
        console.log("[DEBUG] Customer in store:", customer);
        console.log("[DEBUG] Full chat store state:", useChatStore.getState());

        if (!customer) {
            console.log("[DEBUG] No customer found, redirecting to home");
            navigate("/"); // Redirect to home if no user
            return;
        }

    // Verify whether customer is actually a returning (has leads) or truly new
        const ensureNewCustomerFlow = async () => {
            const mobile = customer?.mobile || customer?.mobileNumber;
            if (!mobile) {
                setCheckingStatus(false);
                return;
            }

            // Respect suppression set by resume actions to avoid immediate redirect-flicker
            const suppressionUntil = useChatStore.getState().suppressAutoRedirectUntil || 0;
            if (Date.now() < suppressionUntil) {
                console.log('[Bizzie] Auto-redirect suppressed until', new Date(suppressionUntil).toISOString());
                setCheckingStatus(false);
                return;
            }

            try {
                const status = await checkCustomerStatus(mobile);
                if (!status.isNewCustomer) {
                    console.log('[Bizzie] Customer has existing leads; redirecting to dashboard');
                    navigate('/dashboard', { replace: true });
                    return;
                }
            } catch (error) {
                console.error('[Bizzie] Failed to verify customer status', error);
                // On error, do not immediately redirect — allow user to continue in Bizzie
            } finally {
                setCheckingStatus(false);
            }
        };

        ensureNewCustomerFlow();
    }, [customer, navigate]);

    if (checkingStatus) {
        // Show nothing (or spinner) while verifying to avoid flicker/incorrect navigation
        return null;
    }

    return (
        <>
            <ChatHeader />
            <ChatSection />
        </>
    );
};

export default Bizzie;